import { useCallback, useEffect, useState } from "react";
import useGraphQLClient from "./useGraphQLClient";
import { READ_RELATIONSHIP_DASHBOARD } from "../graph/dashboard/queries";

const useRelationshipDashboard = () => {
  const client = useGraphQLClient();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchDashboard = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await client.request(READ_RELATIONSHIP_DASHBOARD);
      setData(response.readRelationshipDashboard);
    } catch (err) {
      console.error("Failed to load relationship dashboard:", err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [client]);

  useEffect(() => {
    fetchDashboard();
  }, [fetchDashboard]);

  return {
    data,
    loading,
    error,
    refetch: fetchDashboard,
  };
};

export default useRelationshipDashboard;